<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
  <div>
    <!-- <span @click="goPage(leftpage, left)" :style="'color: '+(!leftpage && '#fff;')  " :style="{ fontFamily: FontIssueTitle }  id="left">{{left}}</span> -->
    <span @click="goPage(leftpage, left)" :style="{ color: !leftpage ? '#fff' : '', fontFamily: FontIssueTitle }"  id="left">{{left}}</span>
    <span @click="goPage(rightpage, right)" :style="'color: '+(!rightpage && '#fff')" >{{right}}</span>
    
  </div>
</template>

<script>
export default {
  name: 'top',
  inject: ['reload'],
  props: ["left", "right", "leftpage", "rightpage"],
  data() {
    return { 
      issue:'',
      FontIssue:'',
     };
  },
  mounted(){
    if(this.$route.query.issue!=null){
      this.issue=this.$route.query.issue;      
    }
    if( this.issue){
      this.FontIssue=this.$store.state.NewZineindex[this.issue].FontIssueTitle;
    }  
  },
  computed: {
    FontIssueTitle(){
      return this.FontIssue ? `${this.FontIssue}, sans-serif` : '';
    }  
  },
  methods: {
    // 进入其他页面
    goPage: function(path, name){
      // 禁止返回跳出本网站
      if(name === 'Back' && !path && history.length>2){
        this.$router.go(-1);
        return;
      }else if(name === 'Back'){
         this.$router.push({name: 'index'});
         return;
      }
      if(path){
        this.$router.push({name: path});
        return;
      }
    },
   
  },
  
   
};
</script>

<style scoped lang='scss'>

  span{
    // font-family: "MyFont14-ArialMonoMTPro", sans-serif;
    position: fixed;
    top: 0;
    font-size: 0.95rem;
    color: white;
    cursor: pointer;
    mix-blend-mode: difference;
    z-index: 999;
    
    &:first-child{
      left: 0.5rem;
      right: 2.1rem;
    }

    &:last-child{
      right: 0.5rem;
    }

    &:hover{
      font-style: italic;
    }
    
  }

  @media screen and ( max-width: 750px ) {
    span{
      font-size: 0.56rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top.vue